export default "__VITE_ASSET__BUAoyNc7__"